<template>
  <section id="screenerView">
    <div class="row align-center justify-center">
      <div class="column small-6 medium-12 screener-content">
        <NumberBlock class="animate number-block" :number="data.pageNumber" />
        <p class="animate share-note" v-if="!!data.note" v-html="data.note"></p>
        <h2 class="animate" v-if="!!data.title" v-html="data.title"></h2>
        <div class="animate row align-flex-start justify-center card-container">
          <CardElement
            v-for="(card, index) in data.cards"
            :key="`card-${index}`"
            :goal="card.goal"
            :action="card.action"
            :want="card.want"
          />
        </div>
        <ButtonElement
          :class="{'animate justify-self-center secondary': true, disabled: !mainGoal, disabled: !mainGoal}"
          type="button"
          :text="data.buttonText"
          :action="nextQuestion"
        ></ButtonElement>
        <PageMarkers class="animate screener-marker" :numberOfMarkers="numberOfPages" :activeMarker="1" />
      </div>
    </div>

    <!-- <div class="screener-design-bg design-bg"></div> -->

  </section>
</template>

<script>
import advanceQuestion from '@/shared/advanceQuestion'
import ButtonElement from './ButtonElement.vue'
import CardElement from './CardElement.vue'
import NumberBlock from './NumberBlock.vue'
import PageMarkers from './PageMarkers.vue'

export default {
  name: "ScreenerView",
  components: {
    ButtonElement,
    CardElement,
    NumberBlock,
    PageMarkers,
  },
  computed: {
    numberOfPages() {
      return this.$store.state.numberOfPages
    },
    data() {
      return this.$store.state.screener
    },
    mainGoal() {
      return this.$store.state.mainGoal
    }
  },
  methods: {
    nextQuestion() {
      if(!this.mainGoal) return

      advanceQuestion(this.$store)
    }
  }
}
</script>

<style lang="scss">
// .screener-design-bg {
//   background-image: url(../assets/images/question-1.jpg);
//   background-size: 1440px 834px;
// }



  #screenerView {
    height: auto;
    position: relative;
    width: 100%;

    .screener-content {
      padding: 60px 0;

      .number-block {
        animation-delay: 1.25s;
        animation-name: fadeindown;
      }

      .share-note {
        animation-delay: 1s;
        animation-name: fadeindown;
        font-size: 20px;
        line-height: 1.05;
        margin-top: 13px;
        text-align: center;
      }

      h2 {
        animation-delay: 0.5s;
        animation-name: fadeindown;
        font-size: 12vw;
        font-weight: bold;
        line-height: 1.21;
        margin: 26px auto 10px auto;
        text-align: center;

        @media print, screen and (min-width: 25em) {
          font-size: 48px;
        }
      }

      .card-container {
        animation-delay: 0.5s;
        animation-name: fadein;
        margin-bottom: 46px;
        margin-top: 46px;

        @media print, screen and (min-width: 48em) {
          margin-bottom: 10px;
        }
      }

      .secondary {
        animation-delay: 1s;
        animation-name: fadeinup;
        margin-bottom: 50px;
      }

      .screener-marker {
        animation-delay: 1.25s;
        animation-name: fadeinup;
      }
    }
  }
</style>
